import { render, staticRenderFns } from "./clientdashboard-profile-school.vue?vue&type=template&id=429b030c&"
import script from "./clientdashboard-profile-school.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-profile-school.vue?vue&type=script&lang=js&"
import style0 from "./clientdashboard-profile-school.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports